import React from 'react';
import { Controller, Control, FieldValues, Path } from 'react-hook-form';
import styles from './GroupButton.module.scss';

interface GroupButtonProps<TFieldValues extends FieldValues = FieldValues> {
  control: Control<TFieldValues>;
  name: Path<TFieldValues>;
  options: { label: string; value: string }[];
  required?: boolean;
  defaultValue?: string;
}

function GroupButton<TFieldValues extends FieldValues = FieldValues>({
  control,
  name,
  options,
  required,
  defaultValue = "NIE"
}: GroupButtonProps<TFieldValues>) {
  return (
    <Controller
      name={name}
      control={control}
      defaultValue={defaultValue as any}
      rules={required ? { required: 'To pole jest wymagane' } : {}}
      render={({ field, fieldState }) => (
        <div className={styles.groupButtonWrapper}>
          {options.map((option) => (
            <button
              key={option.value}
              type="button"
              className={
                field.value === option.value
                  ? styles.activeButton
                  : styles.inactiveButton
              }
              onClick={() => field.onChange(option.value)}
            >
              {option.label}
            </button>
          ))}
          {fieldState.error && (
            <span className={styles.errorMessage}>{fieldState.error.message}</span>
          )}
        </div>
      )}
    />
  );
}

export default GroupButton;